export const removeProp = (
	sourceCode: string,
	{
		prop,
		componentName,
	}: {
		prop: string;
		componentName: string;
	},
) => {
	const regex = new RegExp(`(<${componentName}[^>]*?)\\s*${prop}=(?:"[^"]*"|\{[^}]*\})`, 'g');
	return sourceCode.replace(regex, '$1');
};
